module.exports = __webpack_public_path__ + "static/Unify-2-dark-299b59d2e8fcf9b20bfea0d7c4c6bc08.svg";